<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
	<transition name="slide-fade">
		<div class="page work">
			<ul class="project-list">
				<li v-for="project in projects" class="project">
					<img class="project__thumbnail" v-if="project.thumbnail && project.thumbnail != ''" v-bind:src="imagePath(project.thumbnail)"/>
					<h2 class="project__title">{{project.title}}</h2>
					<p class="project__description">{{project.description}}</p>
					<a class="project__link" v-bind:href="project.link" v-if="project.link && project.link != ''">View
						the site</a>
				</li>
			</ul>
		</div>
	</transition>
</template>
<style lang="scss" scoped>
	.work {
		text-align: left;
	}

	.project-list {
		margin: 0;
		padding: 0;
	}

	.project {
		display: inline-block;
		height: auto;
		list-style: none;
		clear: both;
		border-radius: 3px;
		padding: 20px;
		margin-bottom: 10px;
		transition: background 0.2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.project:hover {
		background: rgba(6, 25, 47, 0.6);
	}

	.project__title {
		font-size: 16px;
		text-transform: uppercase;
		margin-top: 0;
	}

	.project__thumbnail {
		float: left;
		margin: 0 20px 15px 0;
		max-width: 200px;
	}

	.project__description {
		font-size: 14px;
	}

	.project__link {
	}

	@media only screen and (max-width: 600px) {
		.project__thumbnail {
			max-width: 80px;
		}
		.project__link {
			float: right;
		}
	}
</style>
<script type="text/babel">
	export default{
		data(){
			return {
				projects: [
					{
						title:       'PMH Advertising',
						thumbnail:   'pmh.png',
						description: 'I developed the front-end for this agency portfolio site in collaboration with Clockwork. I wrote a custom module-based Javascript framework using Webpack and designed the animations with PMH using Greensock. I worked with clockwork to develop a JSON API to communicate with the Craft CMS.',
						link:        '//pmhadv.com'
					},
					{
						title:       'Blue Cross Blue Shield Communities',
						thumbnail:   'bcbs.png',
						description: 'For this educational quiz game, I animated and developed a Javascript application using Webpack, Greensock and a custom, object-oriented JS framework. Layouts and animations were built using a mobile-first approach, but the vector-based artwork scales nicely to larger sizes.',
						link:        '//pullingtogethermn.com/quiz/'
					},
					{
						title:       'Pressure iPad App',
						thumbnail:   'pressure.png',
						description: 'For Pressure, I collaborated with James Cameron’s non-profit organization to develop an interface for manipulating a 3d model of Cameron’s deep sea vessel. I integrated the supplied 3D models and developed the interface and animations in C# with Unity3D. Assisted in integrating the Unity project into a WebView-based iOS app. (Currently unreleased)',
						link:        ''
					},
					{
						title:       'Breeze Avenue',
						thumbnail:   'breezeave.png',
						description: 'Breeze Ave is an interactive book/art piece, consisting of millions of pages of content that change over time. For this piece, I developed a web interface and menu system using React. Designed the page transitions using purely CSS animation and iterated the user interface to the client’s specifications in an Agile workflow. Collaborated with the PHP developer to write JSON APIs to efficiently pass information from Laravel to React. (Currently unreleased)',
						link:        ''
					},
					{
						title:       'National Marrow Donor Program Mobile Registration',
						thumbnail:   'nmdp.png',
						description: 'The sign-up process for marrow donation was a dauntingly-long, desktop-only form. At Clockwork, I worked on-site in an Agile environment with NMDP to subdivide registration into multiple steps that are easier to digest. I developed the front-end code and assisted its integration into a legacy .NET platform. I also delivered a static, mobile-first best-practices site for the client’s reference.',
						link:        '//bethematch.org/'
					},
					{
						title:       'Cracker Jack Mobile Games',
						thumbnail:   'crackerjack.png',
						description: 'An iOS and Android mobile app built with the Starling game engine. At Clockwork, I developed the menu system for the game and assisted in development of several mini-games.',
						link:        '//itunes.apple.com/us/app/cracker-jack/id622864095?mt=8'
					},
					{
						title:       'Just Bare Chicken',
						thumbnail:   'justbare.png',
						description: 'One of three sites ported to Drupal from a legacy .NET system. I developed the front end for this consumer site, as well as a B2B site. I wrote Drupal themes, assisted with Drupal development and worked with Clockwork’s PHP developers to integrate the themes into the sites',
						link:        '//www.justbarechicken.com/'
					},
					{
						title:       'NY Public Library Centennial',
						thumbnail:   'nypl.png',
						description: 'For this special occasion, I developed custom Drupal templates and modules and integrated them into established production and development environments. I programmed both the front-end HTML/CSS and the Drupal PHP that integrated into their existing site. I also built a dynamic flash “quilt” which displays user-submitted content as well as content seeded by the library. I used XML to pass information between custom drupal modules and the AS3 code, which leverages a simple MVC design pattern that I built for previous Flash projects.',
						link:        ''
					},
					{
						title:       'Lufthansa Virtual Pilot I & II',
						thumbnail:   'virtualpilot.png',
						description: 'A geography quiz game that went viral, with over 2 million unique hits in 2010. The celebrity Stephen Fry wrote an unsolicited tweet to his 1.7 million fans that it was a “Brilliant game.” I created the game concept and mechanics, developed the Flash game and a small CodeIgniter site for it to live on. The game was so successful that Lufthansa ordered a sequel that included multiple time-locked trips and Facebook integration.',
						link:        '//www.lufthansa-vp.com/'
					},
					{
						title:       'Reuters Person Selector',
						thumbnail:   'reuters-persona.png',
						description: 'An internal tool to educate Reuters managers and editors on how to better serve their clients. I was given UX & design documents, art assets and built the project in AS3 using a custom MVC design pattern which leverages the RobotLegs and AS3Signals libraries. The site’s content is extracted from an XML file, a more reasonable solution than a full CMS in this particular case. The tool was then integrated into an existing Jaxer server that is hosted internally at Reuters.. I programmed both the front-end HTML/CSS and the Drupal PHP that integrated into their existing site. I also built a dynamic flash “quilt” which displays user-submitted content as well as content seeded by the library. I used XML to pass information between custom drupal modules and the AS3 code, which leverages a simple MVC design pattern that I built for previous Flash projects.',
						link:        '/static/client-work/reuters/persona-selector/persona-selector.html'
					},
					{
						title:       'Reuters Virtual Assignment Desk',
						thumbnail:   'reuters-vadesk.png',
						description: 'Another internal tool for Reuters. This game drives home the concept of allocating limited resources to Reuters managers. It was programmed using the same AS3 MVC design pattern as the Persona Selector and integrated onto the same Jaxer server.. I programmed both the front-end HTML/CSS and the Drupal PHP that integrated into their existing site. I also built a dynamic flash “quilt” which displays user-submitted content as well as content seeded by the library. I used XML to pass information between custom drupal modules and the AS3 code, which leverages a simple MVC design pattern that I built for previous Flash projects.',
						link:        '/static/client-work/reuters/vadesk/virtual-assignment-desk.html'
					}
				]
			}
		},
		methods:    {
			imagePath: function(image) {
				return '/static/images/' + image;
			}
		},
		components: {}
	}
</script>



// WEBPACK FOOTER //
// Work.vue?d0f0d2bc